import { gql } from '@apollo/client';

export default gql`
  query MatchStatuses($matchIds: [Int!]!) {
    matchStatuses(matchIds: $matchIds) {
      competitionSeason
      kickOff
      lastUpdated
      matchId
      name
      date
      status
      versions {
        version
        status
        createdAt
      }
      week
    }
  }
`;
